<template>
  <div class="team">
    <!-- <div>
      <p>address | role | concepts | Edit
      <br>
      ---<br>
      Role: Admin \/<br>
      Concepts: All \/<br>
      Cancel | Save<br>
      ---<br>
      enter address | role | concepts | Add
      </p>
    </div> -->

    <br>
    <h3>Piping</h3>
    <PipeSettings></PipeSettings>

    <br>
    <br>
    <h3>Team</h3>
    <div v-if="$store.state.org.users.length == 0">Fetching users...</div>
    <div class="error" v-if="$store.state.org.teamErrorMessage">{{ $store.state.org.teamErrorMessage }}</div>
    <div class="user-list">
      <UserSummary v-for="(user, index) in $store.state.org.users" :key="index" :user="user" ></UserSummary>

      <div class="user-new">
        <div style="display: flex; align-items: center; grid-gap: 16px;">
          <input v-model="newUserWallet" placeholder="Enter wallet address" />
          <p>Concepts:
            <input type="radio" id="permissions-all" value="all" v-model="newUserPermissions" />
            <label for="permissions-all">all</label>

            <input type="radio" id="permissions-some" value="some" v-model="newUserPermissions" />
            <label for="permissions-some">some</label>
          </p>
        </div>
        <button @click="addUserToTrust()">+ Add user</button>
      </div>
      <p v-if="localError != ''">{{ localError }}</p>
    </div>
  </div>
</template>

<script>
import UserSummary from '@trust/components/UserSummary.vue'
import PipeSettings from '@trust/components/PipeSettings.vue'

export default {
  name: 'Team',
  components: {
    UserSummary,
    PipeSettings
  },
  data() {
      return {
        newUserWallet: null,
        newUserPermissions: 'all',
        localError: '',
      }
  },
  computed: {
  },
  mounted() {
    this.$store.dispatch('fetchUsers');
  },
  methods: {
    addUserToTrust(){
      if(this.newUserWallet == null || ''){
        this.localError = 'Please provide a wallet address.'
        return;
      }
      this.localError = '';
      console.log(this.newUserWallet, this.newUserPermissions)
      this.$store.dispatch('addUser', {userWallet: this.newUserWallet, permissions: this.newUserPermissions});
      this.newUserWallet = null;
    },
  },
}

</script>

<style>
.team {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: scroll;
}

.user-list {
  width: 100%;
  height: 100%;
}

.user-new {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}


</style>
